import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";
import qs from "qs";

const API_URL = process.env.BFF_URL;

class WhitelistService {

  create(customerId, data) {
    return http.post(API_URL + `/v1/customers/${customerId}/visits`, data, { headers: authHeader() });
  }

  update(customerId, id, data) {
    return http.put(API_URL + `/v1/customers/${customerId}/visits/${id}`, data, { headers: authHeader() });
  }

  checkIn(customerId, id) {
    return http.put(API_URL + `/v1/customers/${customerId}/visits/${id}/check-in`, null, { headers: authHeader() });
  }

  checkOut(customerId, id) {
    return http.put(API_URL + `/v1/customers/${customerId}/visits/${id}/check-out`, null, { headers: authHeader() });
  }

  cancel(customerId, id) {
    return http.put(API_URL + `/v1/customers/${customerId}/visits/${id}/cancel`, null, { headers: authHeader() });
  }

  findById(customerId, id) {
    return http.get(API_URL + `/v1/customers/${customerId}/visits/${id}`, { headers: authHeader() });
  }

  find(customerId, params) {
    return http.get(API_URL + `/v1/customers/${customerId}/visits`, { params: params, paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat'} )
      }, headers: authHeader() });
  }

  findByCustomerId(customerId, params) {
    return http.get(API_URL + `/v1/customers/${customerId}/visits`, { params: params, paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat'} )
      }, headers: authHeader() });
  }

  delete(customerId, id) {
    return http.delete(API_URL + `/v1/customers/${customerId}/visits/${id}`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new WhitelistService();



// WEBPACK FOOTER //
// ./src/service/appointment.service.js